import WrapRedux,{actions, connect} from "@modules/wrap-redux/index";
import {MsgInFe} from "@config/MsgInFe";
import createMsg from "@modules/createMsg";
import dataApi from '@config/api.js';
import setlogByMsg from '@modules/setlogByMsg';

function judgeMsgInFE(msg){
  //判断msg是否属于前端配置
  let value = msg.value;
  for(var i = 0;i<MsgInFe.length;i++){
    for(var j= 0;j<MsgInFe[i].msg.length;j++){
      var word = MsgInFe[i].msg[j];
      if(value.search(word)>-1){
        //
        console.log("匹配");
        let result = JSON.parse(JSON.stringify(MsgInFe[i].reply.data));
        return result;
      }
    }
  }
  return false;
}

let pageNum = 1;
let pid = '';
WrapRedux.model({
    name:"chatAreaData",
    initialState:{
      isFetching:false,
      renderData:[]
    },
    reducers:{//参数1 state 参数2 action.data
        addUserMsg(state,data){
          let renderData = state.renderData.concat([data]);
          return {
            isFetching:true,
            renderData,
          }
        },
        addChatBotMsg(state,data){
          setlogByMsg(data);
          let renderData = state.renderData.concat(data);
          return {
            isFetching:false,
            renderData,
          }
        },
        addHistotyMsg(state,data){
          let renderData = data.concat(state.renderData);
          return {
            isFetching:false,
            renderData,
          }
        },
        finishChatItem(state,data){
          //这个actini的使用现在写在每个对话形式组件 没使用高阶组件 后续等hook出来 改为hook引用
          state.renderData[data.index].isFinished = true;
          return state;
        },
    },
    effects:{
      sendMsg:(msg)=>{
        if(msg.value !=="换一换" && msg.value !=="换一批"){
          pageNum =1;
          pid = '';
        }else{
          pageNum++;
        }
        let errInfo = [{type:1,returnMessage:"抱歉，小聘现在有点忙，请稍后再试试"}];
        actions.chatAreaData.addUserMsg({data:msg});
        let result = judgeMsgInFE(msg);
        if(result){
          //前端匹配了
          return (dispatch,getState) =>{
            setTimeout(function(){
              let msg = createMsg({data:result},0)
             actions.chatAreaData.addChatBotMsg({data:msg})
            },700)
           }
        }
        return (dispatch,getState) =>{
          //去后端获取数据
          msg.value = encodeURI(encodeURI(msg.value));
          let url = `${dataApi.chat}?message=${msg.value}&pageNum=${pageNum}&platform=m&pageSize=4&pid=${pid}`;
          fetch(url,{
            mode: 'cors',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
          })
          .then(function(response) {
              return response.text()
          }).then(function(data) {
                data = JSON.parse(data);
                data = data.resultEntity || {};
                console.log(data,1900)
                let msg;
                if(data.code<=0){
                  msg = createMsg({data:errInfo},0)
                }else{
                  const list = data.data || [];
                  pid = list.length>1 && ((list[1]||{}).tracelog||{}).pid || '';
                  msg = createMsg({data:list},0)
                }
                actions.chatAreaData.addChatBotMsg({data:msg});
                if(data.tagOptions != undefined){
                  actions.inputAreaData.refreshTag({data:data.tagOptions})
                }
          }).catch(function(){
            let msg = createMsg({data:errInfo},0)
            actions.chatAreaData.addChatBotMsg({data:msg});
          })
        }
      }
    }
  })

  WrapRedux.model({
    name:"inputAreaData",
    initialState:{
        value:'',
        tags:[],
    },
    reducers:{//参数1 state 参数2 action.data
        changeInputValue(state,data){
          return {
            ...state,
            value:data
          }
        },
        refreshTag(state,data){
          return {
            ...state,
            tags:data,
          }
        }
    },
    effects:{
    }
})